import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuProps } from 'antd';

import { StyledMainTitleWrapper, StyledPageTitle, StyledPageWrapper } from '@/modules/Categories/components/Styled';
import { Menu } from '@/ui';
import { useQueryParams } from '@/hooks';
import { ContentPagesTabs, getContentPagesTabsConfig } from '@/modules/ContentPages/helpers/contentPagesTabsConfig';

const ContentPagesMainContainer = () => {
  const { t } = useTranslation(['common', 'categories']);
  const tabsConfig = useMemo(() => getContentPagesTabsConfig(t), [t]);
  const menuItems = useMemo(() => tabsConfig.map(({ label, key }) => ({ label, key })), [tabsConfig]);
  const tabParam = useQueryParams('tab');
  const allowedKeys = tabsConfig.map((item) => item.key as string);
  const defaultKey = allowedKeys.includes(tabParam ?? '') ? (tabParam as ContentPagesTabs) : ContentPagesTabs.BLOG;
  const [selectedKey, setSelectedKey] = useState<ContentPagesTabs>(defaultKey);
  const selectedTab = useMemo(() => tabsConfig.find((item) => item.key === selectedKey), [selectedKey, tabsConfig]);

  const onClick: MenuProps['onClick'] = (e) => {
    setSelectedKey(e.key as ContentPagesTabs);
  };

  return (
    <StyledPageWrapper>
      <StyledMainTitleWrapper>
        <StyledPageTitle>{t('content_pages_list_title')}</StyledPageTitle>
        <Menu mode="horizontal" items={menuItems} selectedKeys={[selectedKey]} onClick={onClick} />
      </StyledMainTitleWrapper>

      {selectedTab?.content}
    </StyledPageWrapper>
  );
};

export default ContentPagesMainContainer;
